import * as actionTypes from "../actionTypes";

const initialState = {
  loading: false,

  labelsList: null,
  labelsListError: null,

  labelsServiceList: null,
  labelsServiceListError: null,

  parentLabelList: null,
  parentLabelError: null,

  parentLabelData: null,
  parentLabelDataError: null,

  success: null,
  error: null,
  activeLabelService: null

};

export const labelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_LABELS_LIST_START:
      return {
        ...state,
        loading: true,
        labelsList: null,
        labelsServiceList:null,
        parentLabelList: null,
        parentLabelData: null,
        parentLabelDataError: null,
        labelsListError: null
      };
    case actionTypes.GET_LABELS_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        labelsListError: null,
        labelsList: action.payload,
      }
    }
    case actionTypes.GET_LABELS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        labelsListError: action.payload,
        labelsList: null,
      };

      // upload labels list
    case actionTypes.UPLOAD_LABELS_LIST_START:
      return {...state, loading: true,error: null,success: null};


    case actionTypes.GET_LABELS_SERVICE_LIST_START:
      return {...state, loading: true,labelsServiceList:null,activeLabelService:null, labelsServiceListError: null};
    case actionTypes.GET_LABELS_SERVICE_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        labelsServiceListError: null,
        labelsServiceList: action.payload,
      }
    }

    case actionTypes.GET_LABELS_SERVICE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        labelsServiceListError: action.payload,
        labelsServiceList: null,
        activeLabelService:null,
      };

    case actionTypes.GET_PARENT_LABELS_LIST_START:
      return {
        ...state,
        loading: true,
        labelsList: null,
        labelsListError: null,
        // parentLabelList: null,
        parentLabelListError: null,
        activeLabelService:null,
      };
    case actionTypes.GET_PARENT_LABELS_SUCCESS: {
      return {
        ...state,
        loading: false,
        parentLabelListError: null,
        parentLabelList: action.payload,
      }
    }
    case actionTypes.GET_PARENT_LABELS_FAILURE:
      return {
        ...state,
        loading: false,
        parentLabelListError: action.payload,
        parentLabelList: null,
      };

    case actionTypes.LICENSE_LABEL_START:
      return {...state, loading: true, error: null, success: null};

    case actionTypes.ADD_NEW_LABEL_START:
      return {...state, loading: true, error: null, success: null};

    case actionTypes.ADD_NEW_LABEL_SERVICE_START:
      return {...state, loading: true, error: null, success: null};
      
    case actionTypes.EDIT_LABEL_SERVICE_START:
      return {...state, loading: true, error: null, success: null};

    case actionTypes.ADD_NEW_PARENT_LABEL_START:
      return {...state, loading: true, error: null, success: null};

    case actionTypes.ADD_NEW_LABEL_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        success: action.payload.message,
      }
    }
    case actionTypes.ADD_NEW_LABEL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    case actionTypes.GET_PARENT_LABEL_DATA_START:
      return {...state, loading: true, error: null, success: null,activeLabelService:null, parentLabelData: null, parentLabelDataError: null};
    case actionTypes.GET_PARENT_LABEL_DATA_SUCCESS: {
      return {
        ...state,
        loading: false,
        parentLabelData: action.payload,
        parentLabelDataError: null,
        error: null,
        success: null,
      }
    }
    case actionTypes.GET_PARENT_LABEL_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        parentLabelData: null,
        parentLabelDataError: action.payload,
        error: action.payload,
        success: null,
      };

    case actionTypes.LABELS_MESSAGE_HANDLER:
      return {
        ...state,
        labelsListError: action.payload,
        labelsServiceListError: action.payload,
        error: action.payload,
        success: action.payload,
      };
    case actionTypes.ACTIVE_lABEL_SERVICE:
      return {
        ...state,
        activeLabelService: action.payload
      };
    default:
      return {...state};
  }
};
